// components/layout/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  // Get current year dynamically
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <p className="copyright">
        © {currentYear} Tinubu Ambode Supporters. All rights reserved
      </p>
    </footer>
  );
};

export default Footer;